import { TextStyle, Texture, Text, Point } from "pixi.js";
import { ButtonWithScaleAnimation } from "./ButtonWithScaleAnimation";

export class ButtonWithScaleAnimationAndText extends ButtonWithScaleAnimation {
    private readonly buttonText: Text;

    public set buttonTextPosition(value: Point) {
        this.buttonText.position = value;
    }

    public constructor(texture: Texture, text: string, textStyle: TextStyle) {
        super(texture);
        this.buttonText = new Text(text, textStyle);
        this.buttonText.position.set(this.width * 0.5 - this.buttonText.width * 0.5, this.height * 0.5 - this.buttonText.height * 0.5);
        this.defaultView.addChild(this.buttonText);
    }
}
